// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"114":"bc8ccbfceb9f70757c94","636":"3bc021c8088b91f0dce2","896":"dbeb422b156ebad22059"}[chunkId] + ".js";
};